module.exports = __webpack_public_path__ + "img/learn-about-new-weapons.886d6429.jpg";